import { FETCH_FILTERS_REQUEST } from './../const';

export default () => {
  return {type: FETCH_FILTERS_REQUEST}
};
